import Highway from '@dogstudio/highway';
import { animateIn } from '../animations/studio';
import { mq } from '../util/matchMedia';
import { readGlobalState } from '../util/helpers';
import { studioCarousel } from '../components/studioCarousel';
class Studio extends Highway.Renderer {

  constructor(properties) {
    super(properties);
    this.breakpoint = null;
    this.gallery = null;
    this.media = null;
  }

  onEnter() {
    mq.init();
    this.breakpoint = readGlobalState('mq');
    studioCarousel.init(1);
  }

  onEnterCompleted() {
    animateIn.init();
  }

  onLeave() {
    studioCarousel.pause();
  }

  getReferenceElements() {
    // Mobile or desktop gallery, depending on breakpoint
    this.gallery = document.querySelector(`.js-studio-gallery-${this.breakpoint}`);
    this.media = this.gallery.querySelectorAll('.js-studio-gallery-media');
  }

}

export default Studio;
